import moment, { type MomentInput } from 'moment';
import {FormattedMessage} from 'react-intl';

export type DateAndHourProps = {
  children: number | MomentInput;
};

const DateAndHour = ({children} : DateAndHourProps) => {
  const d: MomentInput = moment(children);
  const date = d.format('DD/MM/YYYY');
  const hour = d.format('H:mm');
  return <>
    {date} <FormattedMessage id="at" /> {hour}
  </>;
};

export default DateAndHour;